import { useLingui } from "@lingui/react/macro";
import {
  Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@rakazo/ui-web";
import { Check, ChevronDown } from "lucide-react";

export function ConversationMenu({ conversations, selectedThreadId, onSelect }: {
  conversations: Array<{ threadId: string; label: string; provider: "web" | "teams" }>;
  selectedThreadId: string | null;
  onSelect: (threadId: string | null) => void;
}) {
  const { t } = useLingui();
  if (conversations.length < 2) return null;
  const selected = conversations.find((c) => c.threadId === selectedThreadId) ?? conversations[0]!;
  return <DropdownMenu>
    <DropdownMenuTrigger
      aria-label={t`Choose conversation`}
      render={<Button variant="floating" className="app-no-drag min-w-0 max-w-20 gap-1.5 md:max-w-48" />}
    >
      <span className="truncate">{selected.provider === "web" ? t`Web chat` : selected.label}</span>
      <ChevronDown className="size-3.5 shrink-0" />
    </DropdownMenuTrigger>
    <DropdownMenuContent align="start" className="max-w-80">
      {conversations.map((conversation) => <DropdownMenuItem
        key={conversation.threadId}
        onClick={() => onSelect(conversation.provider === "web" ? null : conversation.threadId)}
      >
        <span className="min-w-0 flex-1 truncate">{conversation.provider === "web" ? t`Web chat` : conversation.label}</span>
        {selected.threadId === conversation.threadId ? <Check className="size-4" /> : null}
      </DropdownMenuItem>)}
    </DropdownMenuContent>
  </DropdownMenu>;
}
